// import React, { useRef ,useState} from "react";
// import * as XLSX from "xlsx";
// import "./FilteredTable.css";
// import OpenTable from "./OpenTable"; // New component
// import DSTable from "./DSTable";     // New component

// const FilteredTable = ({ data }) => {
//   const dayWiseTableRef = useRef(null);
//   const weeklyTableRef = useRef(null);
//   const monthlyTableRef = useRef(null);
//   const [activeView, setActiveView] = useState("BR"); // "BR", "Open", "DS"
//   const [loading, setLoading] = useState(false);

//   const scrollToTable = (ref) => {
//     ref.current.scrollIntoView({ behavior: "smooth" });
//   };

//   const handleViewChange = (view) => {
//     setLoading(true);
//     setActiveView(view);
//     setTimeout(() => setLoading(false), 500); // Simulate delay
//   };
  
//   const parseDate = (dateString) => {
//     if (!dateString) return null;
//     const date = new Date(dateString);
//     return isNaN(date.getTime()) ? null : date;
//   };

//   const formatDate = (date) => {
//     return date
//       ? date.toLocaleDateString("en-GB", {
//           day: "2-digit",
//           month: "2-digit",
//           year: "numeric",
//         })
//       : "";
//   };

//   const aggregateData = (data) => {
//     const aggregated = data.reduce((acc, item) => {
//       const existingRecord = acc.find(
//         (record) =>
//           record.Manager_Name === item.Manager_Name &&
//           record.manager_identifier === item.manager_identifier &&
//           record.Organization_PID === item.Organization_PID &&
//           record.Organization_Project_Name === item.Organization_Project_Name &&
//           record.Date === item.Date
//       );
  
//       if (existingRecord) {
//         // Normal totals
//         existingRecord.Total_Applications_in_BR_DI += (item.Total_Applications_in_BR_DI || 0) + (item.Total_Applications_in_BR_MSME || 0);
//         existingRecord.Total_Applications_in_BR_DFL += (item.Total_Applications_in_BR_DFL || 0);
//         existingRecord.Total_Applications_in_BR_YC += (item.Total_Applications_in_BR_YC || 0);
  
//         // Aborted totals
//         existingRecord.Total_Applications_in_aborted_BR_DI += (item.Total_Applications_in_aborted_BR_DI || 0) + (item.Total_Applications_in_BR_aborted_MSME || 0);
//         existingRecord.Total_Applications_in_BR_aborted_DFL += (item.Total_Applications_in_BR_aborted_DFL || 0);
//         existingRecord.Total_Applications_in_BR_aborted_YC += (item.Total_Applications_in_BR_aborted_YC || 0);
  
//         // Net totals
//         existingRecord.Total_Applications_in_BR_DI_Net += (item.Total_Applications_in_BR_DI_Net || 0) + (item.Total_Applications_in_BR_MSME_Net || 0);
//         existingRecord.Total_Applications_in_BR_DFL_Net += (item.Total_Applications_in_BR_DFL_Net || 0);
//         existingRecord.Total_Applications_in_BR_YC_Net += (item.Total_Applications_in_BR_YC_Net || 0);
//       } else {
//         acc.push({
//           ...item,
//           // Normal
//           Total_Applications_in_BR_DI: (item.Total_Applications_in_BR_DI || 0) + (item.Total_Applications_in_BR_MSME || 0),
//           Total_Applications_in_BR_DFL: (item.Total_Applications_in_BR_DFL || 0),
//           Total_Applications_in_BR_YC: (item.Total_Applications_in_BR_YC || 0),
  
//           // Aborted
//           Total_Applications_in_aborted_BR_DI: (item.Total_Applications_in_aborted_BR_DI || 0) + (item.Total_Applications_in_BR_aborted_MSME || 0),
//           Total_Applications_in_BR_aborted_DFL: (item.Total_Applications_in_BR_aborted_DFL || 0),
//           Total_Applications_in_BR_aborted_YC: (item.Total_Applications_in_BR_aborted_YC || 0),
  
//           // Net
//           Total_Applications_in_BR_DI_Net: (item.Total_Applications_in_BR_DI_Net || 0) + (item.Total_Applications_in_BR_MSME_Net || 0),
//           Total_Applications_in_BR_DFL_Net: (item.Total_Applications_in_BR_DFL_Net || 0),
//           Total_Applications_in_BR_YC_Net: (item.Total_Applications_in_BR_YC_Net || 0),
//         });
//       }
//       return acc;
//     }, []);
  
//     aggregated.sort((a, b) => parseDate(a.Date) - parseDate(b.Date));
//     return aggregated;
//   };
  

// const calculateWeeklyData = (data) => {
//   const weeklyData = data.reduce((acc, item) => {
//     const date = parseDate(item.Date);
//     if (!date) return acc;

//     const dayOfWeek = date.getDay();
//     const mondayOffset = dayOfWeek === 0 ? -6 : 1 - dayOfWeek;
//     const sundayOffset = dayOfWeek === 0 ? 0 : 7 - dayOfWeek;

//     const weekStart = new Date(date);
//     weekStart.setDate(date.getDate() + mondayOffset);

//     const weekEnd = new Date(date);
//     weekEnd.setDate(date.getDate() + sundayOffset);

//     const formatDate = (d) =>
//       `${String(d.getDate()).padStart(2, "0")}/${String(d.getMonth() + 1).padStart(2, "0")}/${d.getFullYear()}`;

//     const weekNumber = Math.ceil(
//       ((weekStart - new Date(date.getFullYear(), 0, 1)) / (1000 * 60 * 60 * 24) + 1) / 7
//     );

//     const weekLabel = `Week ${weekNumber} (${formatDate(weekStart)} - ${formatDate(weekEnd)})`;

//     const key = `${item.Manager_Name}-${item.Organization_Project_Name}`;

//     if (!acc[key]) {
//       acc[key] = {
//         Manager_Name: item.Manager_Name,
//         manager_identifier: item.manager_identifier,
//         Manager_Email: item.Manager_Email, // ✅ add this line
//         Emp_Mgr_Role_ID:item.Emp_Mgr_Role_ID,
//         Organization_PID: item.Organization_PID,
//         Organization_Project_Name: item.Organization_Project_Name,
//       };
//     }

//     if (!acc[key][weekLabel]) {
//       acc[key][weekLabel] = {
//         Total_DI: 0,  // This will now hold the sum of DI and MSME
//         Total_DFL: 0,
//         Total_YC: 0,
//       };
//     }

//     acc[key][weekLabel].Total_DI += (item.Total_Applications_in_BR_DI || 0) + (item.Total_Applications_in_BR_MSME || 0);
//     acc[key][weekLabel].Total_DFL += item.Total_Applications_in_BR_DFL || 0;
//     acc[key][weekLabel].Total_YC += item.Total_Applications_in_BR_YC || 0;

//     return acc;
//   }, {});

//   return Object.values(weeklyData);
// };

  
// const calculateMonthlyData = (data) => {
//   const monthlyData = data.reduce((acc, item) => {
//     const date = parseDate(item.Date);
//     if (!date) return acc;

//     const monthLabel = date.toLocaleString("default", { month: "long", year: "numeric" });
//     const key = `${item.Manager_Name}-${item.Organization_Project_Name}-${monthLabel}`;

//     if (!acc[key]) {
//       acc[key] = {
//         Manager_Name: item.Manager_Name,
//         manager_identifier: item.manager_identifier,
//         Manager_Email: item.Manager_Email, // ✅ Add this line
//         Emp_Mgr_Role_ID:item.Emp_Mgr_Role_ID,
//         Organization_PID: item.Organization_PID,
//         Organization_Project_Name: item.Organization_Project_Name,
//         Month_Date: monthLabel,
//         Total_DI: 0, // New combined DI field
//         Total_Applications_in_BR_DFL: 0,
//         Total_Applications_in_BR_YC: 0,
//       };
//     }

//     // Aggregate counts
//     acc[key].Total_DI += (item.Total_Applications_in_BR_DI || 0) + (item.Total_Applications_in_BR_MSME || 0);
//     acc[key].Total_Applications_in_BR_DFL += item.Total_Applications_in_BR_DFL || 0;
//     acc[key].Total_Applications_in_BR_YC += item.Total_Applications_in_BR_YC || 0;

//     return acc;
//   }, {});

//   return Object.values(monthlyData).sort((a, b) => new Date(`1 ${b.Month_Date}`) - new Date(`1 ${a.Month_Date}`));
// };
  
  
  

//   const aggregatedData = data ? aggregateData(data) : [];
//   const weeklyData = data ? calculateWeeklyData(data) : [];
//   const monthlyData = data ? calculateMonthlyData(data) : [];

//   // First Export Function: Handles dynamic week headers
// const exportToExcelWithDynamicWeeks = (tableData, fileName) => {
//   if (!tableData || tableData.length === 0) {
//     alert("No data available to export");
//     return;
//   }

//   // Extract unique dynamic week headers
//   const dynamicHeaders = Object.keys(tableData[0])
//     .filter((key) => key.startsWith("Week"))
//     .sort((a, b) => {
//       const [_, weekA, monthA, yearA] = a.match(/Week (\d+) - (\w+) - (\d+)/) || [];
//       const [__, weekB, monthB, yearB] = b.match(/Week (\d+) - (\w+) - (\d+)/) || [];
//       const dateA = new Date(`${monthA} 1, ${yearA}`);
//       const dateB = new Date(`${monthB} 1, ${yearB}`);
//       return dateB - dateA || weekB - weekA;
//     });

//   // Define headers for static and dynamic columns
//   const headers = [
//     "Employee Name",
//     "Employee Email",
//     "Manager Id",
//     "PID",
//     "Org Project Name",
//     ...dynamicHeaders.flatMap((week) => [`${week} - DI`, `${week} - DFL`, `${week} - MSME`, `${week} - YC`]),
//   ];

//   // Map the table data to the correct format
//   const worksheetData = tableData.map((item) => {
//     const row = {
//       "Employee Name": item.Manager_Name,
//       "Employee Email": item.manager_identifier
//     ? item.manager_identifier.split('_')[0]
//     : item.Manager_Email || "N/A",
//       "Manager Id":item.Emp_Mgr_Role_ID,
//       PID: item.Organization_PID,
//       "Org Project Name": item.Organization_Project_Name,
//     };

//     // Populate dynamic columns
//     dynamicHeaders.forEach((week) => {
//       const weekData = item[week] || { Total_DI: 0, Total_DFL: 0, Total_MSME: 0, Total_YC: 0 };
//       row[`${week} - DI`] = weekData.Total_DI;
//       row[`${week} - DFL`] = weekData.Total_DFL;
//       row[`${week} - MSME`] = weekData.Total_MSME;
//       row[`${week} - YC`] = weekData.Total_YC;
//     });

//     return row;
//   });

//   // Create a worksheet and workbook
//   const worksheet = XLSX.utils.json_to_sheet(worksheetData, { header: headers });
//   const workbook = XLSX.utils.book_new();
//   XLSX.utils.book_append_sheet(workbook, worksheet, "Data");

//   // Write the file
//   XLSX.writeFile(workbook, `${fileName}.xlsx`);
// };

// // Second Export Function: Handles simpler format with static columns
// const exportToExcelSimple = (tableData, fileName) => {
//   if (!tableData || tableData.length === 0) {
//     alert("No data available to export");
//     return;
//   }

//   // Map the table data to the correct format
//   const worksheetData = tableData.map((item) => ({
//     "Employee Name": item.Manager_Name,
//     "Employee Email": item.manager_identifier
//     ? item.manager_identifier.split('_')[0]
//     : item.Manager_Email || "N/A",
//     "Manager Id":item.Emp_Mgr_Role_ID,
//     PID: item.Organization_PID,
//     "Org Project Name": item.Organization_Project_Name,
//     Date:
//     item.Date
//       ? new Date(item.Date).toLocaleDateString("en-GB", {
//           day: "2-digit",
//           month: "2-digit",
//           year: "numeric",
//         })
//       : item.Month_Date,
//     DI: item.Total_DI || item.Total_Applications_in_BR_DI,
//     DFL: item.Total_DFL || item.Total_Applications_in_BR_DFL,
   
//     YC: item.Total_YC || item.Total_Applications_in_BR_YC,
//   }));

//   // Create a worksheet and workbook
//   const worksheet = XLSX.utils.json_to_sheet(worksheetData);
//   const workbook = XLSX.utils.book_new();
//   XLSX.utils.book_append_sheet(workbook, worksheet, "Data");

//   // Write the file
//   XLSX.writeFile(workbook, `${fileName}.xlsx`);
// };


// return (
//   <div className="table-container">
//     <div className="toggle-buttons">
//       <button onClick={() => handleViewChange("Open")} className={activeView === "Open" ? "active" : ""}>Open View</button>
//       <button onClick={() => handleViewChange("DS")} className={activeView === "DS" ? "active" : ""}>DS View</button>
//       <button onClick={() => handleViewChange("BR")} className={activeView === "BR" ? "active" : ""}>BR View</button>
//     </div>

//     <div className="scroll-buttons fixed-buttons">
//       <button onClick={() => scrollToTable(dayWiseTableRef)}>↓ Day-wise Data</button>
//       <button onClick={() => scrollToTable(weeklyTableRef)}>↓ Weekly Data</button>
//       <button onClick={() => scrollToTable(monthlyTableRef)}>↓ Monthly Data</button>
//     </div>

//     {loading ? (
//       <div className="loading-message">Loading Data...</div>
//     ) : (
//       <>
//         {activeView === "BR" && (
//           <>
//             {/* Monthly Table */}
//             <h2 ref={monthlyTableRef} className="table-title">Monthly Data</h2>
//             <table className="filter-table">
//               <thead>
//                 <tr>
//                   <th>Manager Name</th>
//                   <th>Manager Email</th>
//                   <th>Manager ID</th>
//                   <th>PID</th>
//                   <th>Org Project Name</th>
//                   <th>Month</th>
//                   <th>
//                     Total Applications in BR_DI 
//                     <span className="info-icon" title="Total Applications = DI + MSME applications"> i </span>
//                   </th>
//                   <th>Total Applications in BR_DFL</th>
//                   <th>Total Applications in BR_YC</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {monthlyData.map((item, index) => (
//                   <tr key={index}>
//                     <td>{item.Manager_Name}</td>
//                     <td>
//   {item.manager_identifier
//     ? item.manager_identifier.split('_')[0]
//     : item.Manager_Email || "N/A"}
// </td>


//                     <td>{item.Emp_Mgr_Role_ID}</td>
//                     <td>{item.Organization_PID}</td>
//                     <td>{item.Organization_Project_Name}</td>
//                     <td>{item.Month_Date}</td>
//                     <td>{item.Total_DI}</td>
//                     <td>{item.Total_Applications_in_BR_DFL}</td>
//                     <td>{item.Total_Applications_in_BR_YC}</td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//             <button className="export-button" onClick={() => exportToExcelSimple(monthlyData, "MonthlyData")}>
//               Export Monthly Data
//             </button>

//             {/* Weekly Table */}
//             <h2 ref={weeklyTableRef} className="table-title">Weekly Data</h2>
//             <div className="weekly-table-wrapper">
//               <div className="weekly-table-container">
//                 <table className="weekly-filter-table">
//                   <thead>
//                     <tr>
//                       <th className="sticky-column" rowSpan="2">Manager Name</th>
//                       <th className="sticky-column" rowSpan="2">Manager Email</th>
//                       <th className="sticky-column" rowSpan="2">Manager ID</th>
//                       <th className="sticky-column" rowSpan="2">PID</th>
//                       <th className="sticky-column" rowSpan="2">Org Project Name</th>
//                       {weeklyData.length > 0 &&
//                         Object.keys(weeklyData[0])
//                           .filter((key) => key.startsWith("Week"))
//                           .sort((a, b) => {
//                             const startDateA = new Date(a.match(/\((\d{2}\/\d{2}\/\d{4}) -/)[1].split("/").reverse().join("-"));
//                             const startDateB = new Date(b.match(/\((\d{2}\/\d{2}\/\d{4}) -/)[1].split("/").reverse().join("-"));
//                             return startDateB - startDateA;
//                           })
//                           .map((weekLabel) => (
//                             <th colSpan="3" key={weekLabel}>{weekLabel}</th>
//                           ))}
//                     </tr>
//                     <tr>
//                       {weeklyData.length > 0 &&
//                         Object.keys(weeklyData[0])
//                           .filter((key) => key.startsWith("Week"))
//                           .sort((a, b) => {
//                             const startDateA = new Date(a.match(/\((\d{2}\/\d{2}\/\d{4}) -/)[1].split("/").reverse().join("-"));
//                             const startDateB = new Date(b.match(/\((\d{2}\/\d{2}\/\d{4}) -/)[1].split("/").reverse().join("-"));
//                             return startDateB - startDateA;
//                           })
//                           .flatMap((weekLabel) => [
//                             <th key={`di-${weekLabel}`}>
//                               BR_DI
//                               <span className="info-icon" title="Total Applications = DI + MSME applications"> i </span>
//                             </th>,
//                             <th key={`dfl-${weekLabel}`}>BR_DFL</th>,
//                             <th key={`yc-${weekLabel}`}>BR_YC</th>,
//                           ])}
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {weeklyData.map((item, index) => (
//                       <tr key={index}>
//                         <td className="sticky-column">{item.Manager_Name}</td>
//                         <td className="sticky-column">
//   {item.manager_identifier
//     ? item.manager_identifier.split('_')[0]
//     : item.Manager_Email || "N/A"}
// </td>

//                         <td className="sticky-column">{item.Emp_Mgr_Role_ID}</td>
//                         <td className="sticky-column">{item.Organization_PID}</td>
//                         <td className="sticky-column">{item.Organization_Project_Name}</td>
//                         {Object.keys(item)
//                           .filter((key) => key.startsWith("Week"))
//                           .sort((a, b) => {
//                             const startDateA = new Date(a.match(/\((\d{2}\/\d{2}\/\d{4}) -/)[1].split("/").reverse().join("-"));
//                             const startDateB = new Date(b.match(/\((\d{2}\/\d{2}\/\d{4}) -/)[1].split("/").reverse().join("-"));
//                             return startDateB - startDateA;
//                           })
//                           .flatMap((weekLabel) => {
//                             const weekData = item[weekLabel] || { Total_DI: 0, Total_MSME: 0, Total_DFL: 0, Total_YC: 0 };
//                             const totalDI = (weekData.Total_DI || 0) + (weekData.Total_MSME || 0);
//                             return [
//                               <td key={`di-${weekLabel}`}>{totalDI}</td>,
//                               <td key={`dfl-${weekLabel}`}>{weekData.Total_DFL}</td>,
//                               <td key={`yc-${weekLabel}`}>{weekData.Total_YC}</td>,
//                             ];
//                           })}
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//             <button className="export-button" onClick={() => exportToExcelWithDynamicWeeks(weeklyData, "WeeklyData")}>
//               Export Weekly Data
//             </button>

//             {/* Day-wise Table */}
//             <h2 ref={dayWiseTableRef} className="table-title">Day-wise Data</h2>
//             <table className="filter-table">
//               <thead>
//                 <tr>
//                   <th>Manager Name</th>
//                   <th>Manager Email</th>
//                   <th>Manager ID</th>
//                   <th>PID</th>
//                   <th>Org Project Name</th>
//                   <th>Date</th>
//                   <th>
//                     Total Applications in BR_DI
//                     <span className="info-icon" title="Total Applications = DI + MSME applications"> i </span>
//                   </th>
//                   <th>Total Application in BR_DFL</th>
//                   <th>Total Application in BR_YC</th>
//                   <th>Total Applications in aborted BR_DI</th>
// <th>Total Applications in BR aborted DFL</th>
// <th>Total Applications in BR aborted YC</th>
// <th>Total Applications in BR_DI Net</th>
// <th>Total Applications in BR_DFL Net</th>
// <th>Total Applications in BR_YC Net</th>

//                 </tr>
//               </thead>
//               <tbody>
//                 {aggregatedData.map((item, index) => (
//                   <tr key={index}>
//                     <td>{item.Manager_Name}</td>
//                     <td>
//   {item.manager_identifier
//     ? item.manager_identifier.split('_')[0]
//     : item.Manager_Email || "N/A"}
// </td>

//                     <td>{item.Emp_Mgr_Role_ID}</td>
//                     <td>{item.Organization_PID}</td>
//                     <td>{item.Organization_Project_Name}</td>
//                     <td>{formatDate(parseDate(item.Date))}</td>
//                     <td>{item.Total_Applications_in_BR_DI}</td>
//                     <td>{item.Total_Applications_in_BR_DFL}</td>
//                     <td>{item.Total_Applications_in_BR_YC}</td>
//                     <td>{item.Total_Applications_in_aborted_BR_DI}</td>
// <td>{item.Total_Applications_in_BR_aborted_DFL}</td>
// <td>{item.Total_Applications_in_BR_aborted_YC}</td>
// <td>{item.Total_Applications_in_BR_DI_Net}</td>
// <td>{item.Total_Applications_in_BR_DFL_Net}</td>
// <td>{item.Total_Applications_in_BR_YC_Net}</td>

//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//             <button className="export-button" onClick={() => exportToExcelSimple(aggregatedData, "DayWiseData")}>
//               Export Day-wise Data
//             </button>
//           </>
//         )}

//         {activeView === "Open" && <OpenTable data={data} />}
//         {activeView === "DS" && <DSTable data={data} />}
//       </>
//     )}
//   </div>
// );

// };

// export default FilteredTable;



import React, { useRef ,useState} from "react";
import * as XLSX from "xlsx";
import "./FilteredTable.css";
import OpenTable from "./OpenTable"; // New component
import DSTable from "./DSTable";     // New component

const FilteredTable = ({
  data,
  activeView,
  loading,
  dayWiseRef,
  weeklyRef,
  monthlyRef,
}) => {

  
  const [ setActiveView] = useState("BR"); // "BR", "Open", "DS"
  const [ setLoading] = useState(false);

  const scrollToTable = (ref) => {
    ref.current.scrollIntoView({ behavior: "smooth" });
  };

  const handleViewChange = (view) => {
    setLoading(true);
    setActiveView(view);
    setTimeout(() => setLoading(false), 500); // Simulate delay
  };
  
  const parseDate = (dateString) => {
    if (!dateString) return null;
    const date = new Date(dateString);
    return isNaN(date.getTime()) ? null : date;
  };

  const formatDate = (date) => {
    return date
      ? date.toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        })
      : "";
  };

  const aggregateData = (data) => {
    const aggregated = data.reduce((acc, item) => {
      const existingRecord = acc.find(
        (record) =>
          record.Manager_Name === item.Manager_Name &&
          record.manager_identifier === item.manager_identifier &&
          record.Organization_PID === item.Organization_PID &&
          record.Organization_Project_Name === item.Organization_Project_Name &&
          record.Date === item.Date
      );
  
      if (existingRecord) {
        // Normal totals
        existingRecord.Total_Applications_in_BR_DI += (item.Total_Applications_in_BR_DI || 0) + (item.Total_Applications_in_BR_MSME || 0);
        existingRecord.Total_Applications_in_BR_DFL += (item.Total_Applications_in_BR_DFL || 0);
        existingRecord.Total_Applications_in_BR_YC += (item.Total_Applications_in_BR_YC || 0);
      
        // Aborted totals
        existingRecord.Total_Applications_abort_in_BR_DI += (item.Total_Applications_abort_in_BR_DI || 0) + (item.Total_Applications_abort_in_BR_MSME || 0);
        existingRecord.Total_Applications_abort_in_BR_DFL += (item.Total_Applications_abort_in_BR_DFL || 0);
        existingRecord.Total_Applications_abort_in_BR_YC += (item.Total_Applications_abort_in_BR_YC || 0);
      
        // Net totals
        existingRecord.Total_Applications_net_in_BR_DI += (item.Total_Applications_net_in_BR_DI || 0) + (item.Total_Applications_net_in_BR_MSME || 0);
        existingRecord.Total_Applications_net_in_BR_DFL += (item.Total_Applications_net_in_BR_DFL || 0);
        existingRecord.Total_Applications_net_in_BR_YC += (item.Total_Applications_net_in_BR_YC || 0);
      } else {
        acc.push({
          ...item,
          // Normal
          Total_Applications_in_BR_DI: (item.Total_Applications_in_BR_DI || 0) + (item.Total_Applications_in_BR_MSME || 0),
          Total_Applications_in_BR_DFL: (item.Total_Applications_in_BR_DFL || 0),
          Total_Applications_in_BR_YC: (item.Total_Applications_in_BR_YC || 0),
      
          // Aborted
          Total_Applications_abort_in_BR_DI: (item.Total_Applications_abort_in_BR_DI || 0) + (item.Total_Applications_abort_in_BR_MSME || 0),
          Total_Applications_abort_in_BR_DFL: (item.Total_Applications_abort_in_BR_DFL || 0),
          Total_Applications_abort_in_BR_YC: (item.Total_Applications_abort_in_BR_YC || 0),
      
          // Net
          Total_Applications_net_in_BR_DI: (item.Total_Applications_net_in_BR_DI || 0) + (item.Total_Applications_net_in_BR_MSME || 0),
          Total_Applications_net_in_BR_DFL: (item.Total_Applications_net_in_BR_DFL || 0),
          Total_Applications_net_in_BR_YC: (item.Total_Applications_net_in_BR_YC || 0),
        });
      }
      
      return acc;
    }, []);
  
    aggregated.sort((a, b) => parseDate(a.Date) - parseDate(b.Date));
    return aggregated;
  };
  

const calculateWeeklyData = (data) => {
  const weeklyData = data.reduce((acc, item) => {
    const date = parseDate(item.Date);
    if (!date) return acc;

    const dayOfWeek = date.getDay();
    const mondayOffset = dayOfWeek === 0 ? -6 : 1 - dayOfWeek;
    const sundayOffset = dayOfWeek === 0 ? 0 : 7 - dayOfWeek;

    const weekStart = new Date(date);
    weekStart.setDate(date.getDate() + mondayOffset);

    const weekEnd = new Date(date);
    weekEnd.setDate(date.getDate() + sundayOffset);

    const formatDate = (d) =>
      `${String(d.getDate()).padStart(2, "0")}/${String(d.getMonth() + 1).padStart(2, "0")}/${d.getFullYear()}`;

    const weekNumber = Math.ceil(
      ((weekStart - new Date(date.getFullYear(), 0, 1)) / (1000 * 60 * 60 * 24) + 1) / 7
    );

    const weekLabel = `Week ${weekNumber} (${formatDate(weekStart)} - ${formatDate(weekEnd)})`;

    const key = `${item.Manager_Name}-${item.Organization_Project_Name}`;

    if (!acc[key]) {
      acc[key] = {
        Manager_Name: item.Manager_Name,
        manager_identifier: item.manager_identifier,
        Manager_Email: item.Manager_Email, // ✅ add this line
        Emp_Mgr_Role_ID:item.Emp_Mgr_Role_ID,
        Organization_PID: item.Organization_PID,
        Organization_Project_Name: item.Organization_Project_Name,
      };
    }

    if (!acc[key][weekLabel]) {
      acc[key][weekLabel] = {
        Total_DI: 0,  // This will now hold the sum of DI and MSME
        Total_DFL: 0,
        Total_YC: 0,
      };
    }

    acc[key][weekLabel].Total_DI += (item.Total_Applications_in_BR_DI || 0) + (item.Total_Applications_in_BR_MSME || 0);
    acc[key][weekLabel].Total_DFL += item.Total_Applications_in_BR_DFL || 0;
    acc[key][weekLabel].Total_YC += item.Total_Applications_in_BR_YC || 0;

    return acc;
  }, {});

  return Object.values(weeklyData);
};

  
const calculateMonthlyData = (data) => {
  const monthlyData = data.reduce((acc, item) => {
    const date = parseDate(item.Date);
    if (!date) return acc;

    const monthLabel = date.toLocaleString("default", { month: "long", year: "numeric" });
    const key = `${item.Manager_Name}-${item.Organization_Project_Name}-${monthLabel}`;

    if (!acc[key]) {
      acc[key] = {
        Manager_Name: item.Manager_Name,
        manager_identifier: item.manager_identifier,
        Manager_Email: item.Manager_Email, // ✅ Add this line
        Emp_Mgr_Role_ID:item.Emp_Mgr_Role_ID,
        Organization_PID: item.Organization_PID,
        Organization_Project_Name: item.Organization_Project_Name,
        Month_Date: monthLabel,
        Total_DI: 0, // New combined DI field
        Total_Applications_in_BR_DFL: 0,
        Total_Applications_in_BR_YC: 0,
      };
    }

    // Aggregate counts
    acc[key].Total_DI += (item.Total_Applications_in_BR_DI || 0) + (item.Total_Applications_in_BR_MSME || 0);
    acc[key].Total_Applications_in_BR_DFL += item.Total_Applications_in_BR_DFL || 0;
    acc[key].Total_Applications_in_BR_YC += item.Total_Applications_in_BR_YC || 0;

    return acc;
  }, {});

  return Object.values(monthlyData).sort((a, b) => new Date(`1 ${b.Month_Date}`) - new Date(`1 ${a.Month_Date}`));
};
  
  
  

  const aggregatedData = data ? aggregateData(data) : [];
  const weeklyData = data ? calculateWeeklyData(data) : [];
  const monthlyData = data ? calculateMonthlyData(data) : [];

  // First Export Function: Handles dynamic week headers
const exportToExcelWithDynamicWeeks = (tableData, fileName) => {
  if (!tableData || tableData.length === 0) {
    alert("No data available to export");
    return;
  }

  // Extract unique dynamic week headers
  const dynamicHeaders = Object.keys(tableData[0])
    .filter((key) => key.startsWith("Week"))
    .sort((a, b) => {
      const [_, weekA, monthA, yearA] = a.match(/Week (\d+) - (\w+) - (\d+)/) || [];
      const [__, weekB, monthB, yearB] = b.match(/Week (\d+) - (\w+) - (\d+)/) || [];
      const dateA = new Date(`${monthA} 1, ${yearA}`);
      const dateB = new Date(`${monthB} 1, ${yearB}`);
      return dateB - dateA || weekB - weekA;
    });

  // Define headers for static and dynamic columns
  const headers = [
    "Manager Name",
    "Manager Email",
    "Manager Id",
    "PID",
    "Org Project Name",
    ...dynamicHeaders.flatMap((week) => [`${week} - DI`, `${week} - DFL`, `${week} - MSME`, `${week} - YC`]),
  ];

  // Map the table data to the correct format
  const worksheetData = tableData.map((item) => {
    const row = {
      "Manager Name": item.Manager_Name,
      "Manager Email": item.manager_identifier
    ? item.manager_identifier.split('_')[0]
    : item.Manager_Email || "N/A",
      "Manager Id":item.Emp_Mgr_Role_ID,
      PID: item.Organization_PID,
      "Org Project Name": item.Organization_Project_Name,
    };

    // Populate dynamic columns
    dynamicHeaders.forEach((week) => {
      const weekData = item[week] || { Total_DI: 0, Total_DFL: 0, Total_MSME: 0, Total_YC: 0 };
      row[`${week} - DI`] = weekData.Total_DI;
      row[`${week} - DFL`] = weekData.Total_DFL;
      row[`${week} - MSME`] = weekData.Total_MSME;
      row[`${week} - YC`] = weekData.Total_YC;
    });

    return row;
  });

  // Create a worksheet and workbook
  const worksheet = XLSX.utils.json_to_sheet(worksheetData, { header: headers });
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Data");

  // Write the file
  XLSX.writeFile(workbook, `${fileName}.xlsx`);
};

// Second Export Function: Handles simpler format with static columns
const exportToExcelSimple = (tableData, fileName) => {
  if (!tableData || tableData.length === 0) {
    alert("No data available to export");
    return;
  }

  // Map the table data to the correct format
  const worksheetData = tableData.map((item) => ({
    "Manager Name": item.Manager_Name,
    "Manager Email": item.manager_identifier
    ? item.manager_identifier.split('_')[0]
    : item.Manager_Email || "N/A",
    "Manager Id":item.Emp_Mgr_Role_ID,
    PID: item.Organization_PID,
    "Org Project Name": item.Organization_Project_Name,
    Date:
    item.Date
      ? new Date(item.Date).toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        })
      : item.Month_Date,
    DI: item.Total_DI || item.Total_Applications_in_BR_DI,
    DFL: item.Total_DFL || item.Total_Applications_in_BR_DFL,
   
    YC: item.Total_YC || item.Total_Applications_in_BR_YC,
  }));

  // Create a worksheet and workbook
  const worksheet = XLSX.utils.json_to_sheet(worksheetData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Data");

  // Write the file
  XLSX.writeFile(workbook, `${fileName}.xlsx`);
};


return (
  <div className="table-container">
    {/* <div className="toggle-buttons">
      <button onClick={() => handleViewChange("Open")} className={activeView === "Open" ? "active" : ""}>Open View</button>
      <button onClick={() => handleViewChange("DS")} className={activeView === "DS" ? "active" : ""}>DS View</button>
      <button onClick={() => handleViewChange("BR")} className={activeView === "BR" ? "active" : ""}>BR View</button>
    </div>

    <div className="scroll-buttons fixed-buttons">
      <button onClick={() => scrollToTable(dayWiseTableRef)}>↓ Day-wise Data</button>
      <button onClick={() => scrollToTable(weeklyTableRef)}>↓ Weekly Data</button>
      <button onClick={() => scrollToTable(monthlyTableRef)}>↓ Monthly Data</button>
    </div> */}

    {loading ? (
      <div className="loading-message">Loading Data...</div>
    ) : (
      <>
        {activeView === "BR" && (
          <>
            {/* Monthly Table */}
            
            <h2 ref={monthlyRef}
className="table-title">Monthly Data</h2>
            <table className="filter-table">
              <thead>
                <tr>
                  <th>Manager Name</th>
                  {/* <th>Manager Email</th>
                  <th>Manager ID</th> */}
                  <th>PID</th>
                  <th>Organization/State Name</th>
                  <th>Month</th>
                  <th>
                    Total Applications in BR_DI 
                    <span className="info-icon" title="Total Applications = DI + MSME applications"> i </span>
                  </th>
                  <th>Total Applications in BR_DFL</th>
                  <th>Total Applications in BR_YC</th>
                </tr>
              </thead>
              <tbody>
                {monthlyData.map((item, index) => (
                  <tr key={index}>
                    <td>{item.Manager_Name}</td>
                    {/* <td>
  {item.manager_identifier
    ? item.manager_identifier.split('_')[0]
    : item.Manager_Email || "N/A"}
</td>


                    <td>{item.Emp_Mgr_Role_ID}</td> */}
                    <td>{item.Organization_PID}</td>
                    <td>{item.Organization_Project_Name}</td>
                    <td>{item.Month_Date}</td>
                    <td>{item.Total_DI}</td>
                    <td>{item.Total_Applications_in_BR_DFL}</td>
                    <td>{item.Total_Applications_in_BR_YC}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            <button className="export-button" onClick={() => exportToExcelSimple(monthlyData, "MonthlyData")}>
              Export Monthly Data
            </button>

            {/* Weekly Table */}
            <h2 ref={weeklyRef}
 className="table-title">Weekly Data</h2>
            <div className="weekly-table-wrapper">
              <div className="weekly-table-container">
                <table className="weekly-filter-table">
                  <thead>
                    <tr>
                      <th className="sticky-column" rowSpan="2">Manager Name</th>
                      {/* <th className="sticky-column" rowSpan="2">Manager Email</th>
                      <th className="sticky-column" rowSpan="2">Manager ID</th> */}
                      <th className="sticky-column" rowSpan="2">PID</th>
                      <th className="sticky-column" rowSpan="2">Organization/State Name</th>
                      {weeklyData.length > 0 &&
                        Object.keys(weeklyData[0])
                          .filter((key) => key.startsWith("Week"))
                          .sort((a, b) => {
                            const startDateA = new Date(a.match(/\((\d{2}\/\d{2}\/\d{4}) -/)[1].split("/").reverse().join("-"));
                            const startDateB = new Date(b.match(/\((\d{2}\/\d{2}\/\d{4}) -/)[1].split("/").reverse().join("-"));
                            return startDateB - startDateA;
                          })
                          .map((weekLabel) => (
                            <th colSpan="3" key={weekLabel}>{weekLabel}</th>
                          ))}
                    </tr>
                    <tr>
                      {weeklyData.length > 0 &&
                        Object.keys(weeklyData[0])
                          .filter((key) => key.startsWith("Week"))
                          .sort((a, b) => {
                            const startDateA = new Date(a.match(/\((\d{2}\/\d{2}\/\d{4}) -/)[1].split("/").reverse().join("-"));
                            const startDateB = new Date(b.match(/\((\d{2}\/\d{2}\/\d{4}) -/)[1].split("/").reverse().join("-"));
                            return startDateB - startDateA;
                          })
                          .flatMap((weekLabel) => [
                            <th key={`di-${weekLabel}`}>
                              BR_DI
                              <span className="info-icon" title="Total Applications = DI + MSME applications"> i </span>
                            </th>,
                            <th key={`dfl-${weekLabel}`}>BR_DFL</th>,
                            <th key={`yc-${weekLabel}`}>BR_YC</th>,
                          ])}
                    </tr>
                  </thead>
                  <tbody>
                    {weeklyData.map((item, index) => (
                      <tr key={index}>
                        <td className="sticky-column">{item.Manager_Name}</td>
                        {/* <td className="sticky-column">
  {item.manager_identifier
    ? item.manager_identifier.split('_')[0]
    : item.Manager_Email || "N/A"}
</td>

                        <td className="sticky-column">{item.Emp_Mgr_Role_ID}</td> */}
                        <td className="sticky-column">{item.Organization_PID}</td>
                        <td className="sticky-column">{item.Organization_Project_Name}</td>
                        {Object.keys(item)
                          .filter((key) => key.startsWith("Week"))
                          .sort((a, b) => {
                            const startDateA = new Date(a.match(/\((\d{2}\/\d{2}\/\d{4}) -/)[1].split("/").reverse().join("-"));
                            const startDateB = new Date(b.match(/\((\d{2}\/\d{2}\/\d{4}) -/)[1].split("/").reverse().join("-"));
                            return startDateB - startDateA;
                          })
                          .flatMap((weekLabel) => {
                            const weekData = item[weekLabel] || { Total_DI: 0, Total_MSME: 0, Total_DFL: 0, Total_YC: 0 };
                            const totalDI = (weekData.Total_DI || 0) + (weekData.Total_MSME || 0);
                            return [
                              <td key={`di-${weekLabel}`}>{totalDI}</td>,
                              <td key={`dfl-${weekLabel}`}>{weekData.Total_DFL}</td>,
                              <td key={`yc-${weekLabel}`}>{weekData.Total_YC}</td>,
                            ];
                          })}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
            <button className="export-button" onClick={() => exportToExcelWithDynamicWeeks(weeklyData, "WeeklyData")}>
              Export Weekly Data
            </button>

            {/* Day-wise Table */}
            <h2 ref={dayWiseRef}
 className="table-title">Day-wise Data</h2>
            <table className="filter-table">
            <thead>
  <tr>
    <th>Manager Name</th>
    {/* <th>Manager Email</th>
    <th>Manager ID</th> */}
    <th>PID</th>
    <th>Organization/State Name</th>
    <th>Date</th>

    {/* DI Group */}
    <th>
      Total Applications in BR_DI
      <span className="info-icon" title="Total Applications = DI + MSME applications"> i </span>
    </th>
    {/* <th className="abort-column">Total Applications abort in BR_DI</th>
    <th className="net-column">Total Applications net in BR_DI</th> */}

    {/* DFL Group */}
    <th>Total Applications in BR_DFL</th>
    {/* <th className="abort-column">Total Applications abort in BR_DFL</th>
    <th className="net-column">Total Applications net in BR_DFL</th> */}

    {/* YC Group */}
    <th>Total Applications in BR_YC</th>
    {/* <th className="abort-column">Total Applications abort in BR_YC</th>
    <th className="net-column">Total Applications net in BR_YC</th> */}
  </tr>
</thead>

<tbody>
  {aggregatedData.map((item, index) => (
    <tr key={index}>
      <td>{item.Manager_Name}</td>
      {/* <td>
        {item.manager_identifier
          ? item.manager_identifier.split('_')[0]
          : item.Manager_Email || "N/A"}
      </td>
      <td>{item.Emp_Mgr_Role_ID}</td> */}
      <td>{item.Organization_PID}</td>
      <td>{item.Organization_Project_Name}</td>
      <td>{formatDate(parseDate(item.Date))}</td>

      {/* DI Group */}
      <td>{item.Total_Applications_in_BR_DI}</td>
      {/* <td className="abort-column">{item.Total_Applications_abort_in_BR_DI}</td>
      <td className="net-column">{item.Total_Applications_net_in_BR_DI}</td> */}

      {/* DFL Group */}
      <td>{item.Total_Applications_in_BR_DFL}</td>
      {/* <td className="abort-column">{item.Total_Applications_abort_in_BR_DFL}</td>
      <td className="net-column">{item.Total_Applications_net_in_BR_DFL}</td> */}

      {/* YC Group */}
      <td>{item.Total_Applications_in_BR_YC}</td>
      {/* <td className="abort-column">{item.Total_Applications_abort_in_BR_YC}</td>
      <td className="net-column">{item.Total_Applications_net_in_BR_YC}</td> */}
    </tr>
  ))}
</tbody>

            </table>
            <button className="export-button" onClick={() => exportToExcelSimple(aggregatedData, "DayWiseData")}>
              Export Day-wise Data
            </button>
          </>
        )}

        {activeView === "Open" && <OpenTable data={data}
    dayWiseRef={dayWiseRef}
    weeklyRef={weeklyRef}
    monthlyRef={monthlyRef} />}
        {activeView === "DS" && (
  <DSTable
    data={data}
    dayWiseRef={dayWiseRef}
    weeklyRef={weeklyRef}
    monthlyRef={monthlyRef}
  />
)}

      </>
    )}
  </div>
);

};

export default FilteredTable;
